import Component from '@glimmer/component';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import Icon from './icon.gjs';
import { faSun } from '../icons/regular.js';
import { faMoon } from '../icons/solid.js';

export default class ThemeToggle extends Component {
  @service theme;

  <template>
    <button
      type="button"
      class="swap swap-rotate"
      {{on "click" this.theme.toggle}}
    >
      <Icon @icon={{if this.theme.isDark faMoon faSun}} />
    </button>
  </template>
}
